import { render, staticRenderFns } from "./JobPageBaseInfoBlocks.vue?vue&type=template&id=e32a39ca&scoped=true&"
import script from "./JobPageBaseInfoBlocks.vue?vue&type=script&lang=js&"
export * from "./JobPageBaseInfoBlocks.vue?vue&type=script&lang=js&"
import style0 from "./JobPageBaseInfoBlocks.vue?vue&type=style&index=0&id=e32a39ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32a39ca",
  null
  
)

export default component.exports